<template>
  <div class="pets-search-form__container">
    <GroupBox>
      <div class="pets-search-form__content">
        <div class="pets-search-form__row">
          <div class="pets-search-form__date-selector pets-search-form__select-field">
            <LabeledDateInput
              label="Дата початку дії договору"
              :required-icon="true"
              :placeholder="getStartDatePlaceholder"
              type="input"
              :disabled-past-dates="true"
              :min-date="getMinDate"
              v-model="contract.startDate"
              format="DD.MM.YYYY"
              @change="onChangeContractStartDate"
              @blur="touchField('contract.startDate')"
            />
            <p class="pets-search-form__franchise">Франшиза 10 днів</p>
          </div>
          <LabeledSelect
            class="pets-search-form__select-field"
            label="Період дії договору"
            :required-icon="true"
            placeholder="6 місяців"
            empty-text="Нічого немає"
            type="select"
            label-key="name"
            value-key="id"
            :options="getPetsInsurancePeriods"
            :error-messages="getValidationErrors('contract.estimatedPeriod', {
              required: 'Виберіть період дії договору',
            })"
            v-model="contract.estimatedPeriod"
            @change="onChangeContractEstimatedPeriod"
            @blur="touchField('contract.estimatedPeriod')"
          />
          <LabeledSelect
            class="pets-search-form__select-field"
            label="Комісійна винагорода"
            :required-icon="true"
            placeholder="40%"
            empty-text="Нічого немає"
            type="select"
            label-key="name"
            value-key="value"
            :options="earningsList"
            :is-loading="isLoadingEarnings"
            :error-messages="getValidationErrors('contract.earnings', {
              required: 'Виберіть комісійну винагороду',
            })"
            v-model="contract.earnings"
            @change="onChangeEarnings"
            @blur="touchField('contract.earnings')"
          />
        </div>
      </div>
    </GroupBox>
  </div>
</template>

<script>
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import { petsPeriodLabels } from '@/entities/insurance/config';
import { FRANCHISE_DAYS } from '@/features/pets-calculator/config';
import { DateTimeFormatter } from '@/shared/lib/date-time';
import { ValidateForm } from '@/shared/lib/form';
import { GroupBox, LabeledDateInput, LabeledSelect } from '@/shared/ui/form';

const { formatDateTime } = DateTimeFormatter();

export default {
  props: {
    contractStartDate: {
      type: [String, Date, null],
      default: null,
    },
    contractEstimatedPeriod: {
      type: [String, Number, null],
      default: null,
    },
    earnings: {
      type: [Object, Number, null],
      default: null,
    },
    earningsList: {
      type: Array,
      default: () => [],
    },
    isLoadingEarnings: {
      type: Boolean,
      default: false,
    },
  },
  validations: {
    contract: {
      startDate: { required },
      estimatedPeriod: { required },
      earnings: { required },
    },
  },
  mixins: [ValidateForm],
  data() {
    return {
      contract: {
        startDate: this.contractStartDate,
        estimatedPeriod: this.contractEstimatedPeriod,
        earnings: this.earnings,
      },
    };
  },
  components: { GroupBox, LabeledDateInput, LabeledSelect },
  computed: {
    getPetsInsurancePeriods() {
      return Object.entries(petsPeriodLabels).map(([id, name]) => ({ id, name }));
    },
    getMinDate() {
      return moment().add(FRANCHISE_DAYS, 'days').toDate();
    },
    getStartDatePlaceholder() {
      return formatDateTime(moment().add(FRANCHISE_DAYS, 'days'), 'DD.MM.YYYY');
    },
  },
  watch: {
    contractStartDate(newValue) {
      if (newValue !== this.contract.startDate) {
        this.contract.startDate = newValue;
      }
    },
    contractEstimatedPeriod(newValue) {
      if (newValue !== this.contract.estimatedPeriod) {
        this.contract.estimatedPeriod = newValue;
      }
    },
    earnings(newValue) {
      if (newValue !== this.contract.earnings) {
        this.contract.earnings = newValue;
      }
    },
  },
  methods: {
    formatDateTime,
    onChangeContractStartDate(startDate) {
      this.$emit('changeContractStartDate', new moment(startDate).format('DD.MM.YYYY'));
    },
    onChangeContractEstimatedPeriod(estimatedPeriod) {
      this.$emit('changeContractEstimatedPeriod', estimatedPeriod);
    },
    onChangeEarnings(earnings) {
      this.$emit('changeEarnings', earnings);
    },
    validateAll() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
  },
};
</script>

<style scoped lang="scss">
.pets-search-form {
  &__row {
    display: flex;
    justify-content: space-between;
    gap: 50px;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 5px;
    }
  }

  &__select-field {
    flex: 1;
  }

  &__date-selector {
    margin-bottom: 5px;
  }

  &__franchise {
    font-weight: 400;
    font-size: 10px;
    color: #FF3B30;
    margin: 0;
  }
}
</style>